import React, { useEffect } from 'react';
import LandingPage from './landingPage';
import { BrowserRouter, Route, Routes } from "react-router";
import { useState } from "react";
import './App.css';
import Showcase from './showcase';
import { pagesEnum } from './enums';
import supabase from './client';
import BlogPage from './blogPage';
import FlightPage from './flights';

function App() {
  const [data1, setData] = useState<any>();

  function myFunction() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    var e = document.getElementById("myBar");
    if (e != null) {
      e.style.width = scrolled + "%";
    }
  }
  window.onscroll = function () { myFunction() };

  async function getProjectData() {
    const { data, error } = await supabase
      .from("projects")
      .select('*');
    if(error){
      alert("error retrieving project data");
    }
    setData(data);
  }

  useEffect(() => {
    getProjectData();
  }, []);


  return (
    <BrowserRouter>
      <Routes>
        <Route path={""} element={<LandingPage />}></Route>
        <Route path={pagesEnum.blog} element={<BlogPage />}></Route>
        <Route path={pagesEnum.flights} element={<FlightPage />}></Route>
        {
          data1?.map((data: any, i: any) => (
            <Route path={data.url} key={i} element={<Showcase info={data}></Showcase>}></Route>
          ))
        }
      </Routes>
    </BrowserRouter>
  );
}

export default App;
